import { render, staticRenderFns } from "./AddStatusModal.vue?vue&type=template&id=54458976&"
import script from "./AddStatusModal.vue?vue&type=script&lang=js&"
export * from "./AddStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports